<template>
    <div id="pcViews" v-cloak>
        <main-tar-bar></main-tar-bar>
        <router-view></router-view>
        <Footer />
        <div class="servi-btn" @click="openService">
            <i class="el-icon-service" style="color:#409EFF;font-weight: bold;font-size:30px"></i>
        </div>
        <!-- 返回顶部按钮 -->
        <el-backtop :bottom="200"></el-backtop>
    </div>
</template>

<script>
import MainTarBar from "components/contents/maintarbar/MainTarBar";
import Footer from "components/contents/footer/Footer";
export default {
    name: "pcViews",
    components: {
        MainTarBar,
        Footer,
    },
    methods:{
        openService:()=>{
            window.open('https://kf.spsaas.cn/client/new.html?u=https://kf.spsaas.cn/channel/zyszxxjs/694df5b1db5f219c31c9a45b.js','_blank')
        }
    }
};
</script>

<style>
/*css 引入方式*/
@import "../../assets/css/base.css";
.servi-btn{
    position: fixed;
    right: 35px;
    bottom: 260px;
    z-index: 999;
    width: 50px;
    height: 50px;
    background-color: #FFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 0 6px rgba(0, 0, 0, .12);
    cursor: pointer;
}
</style>
